export const version = "wallet/5.2.0";
